import { useFormContext, Controller, FieldError } from 'react-hook-form';
// Context
import { OnboardingFormData } from 'context/OnboardingContext';
// Ui
import Text from 'ui3/Text/Text';
// Components
import SocialMediaFields from '../SocialMediaFields/SocialMediaFields';

// Styles
import styles from './SocialMediaForm.module.scss';

type SocialMediaFormProps = {
  isNewSocialMediaIntegration?: boolean;
};

const SocialMediaForm = ({
  isNewSocialMediaIntegration,
}: SocialMediaFormProps) => {
  const { errors, control } = useFormContext<OnboardingFormData>();

  // The "at least one account" rule is tested on the array itself, so its message sits on
  // `socialAccounts` rather than on any row, and no row renders it.
  const socialAccountsError = (errors.socialAccounts as FieldError | undefined)
    ?.message;

  return (
    <div className={styles.root}>
      <Controller
        name="socialAccounts"
        control={control}
        render={({ onChange, value }) => {
          return (
            <SocialMediaFields
              socialAccounts={value}
              onChange={onChange}
              errors={errors.socialAccounts}
              isNewSocialMediaIntegration={isNewSocialMediaIntegration}
            />
          );
        }}
      />

      {socialAccountsError && (
        <Text variant="captionRegular" color="error-default" role="alert">
          {socialAccountsError}
        </Text>
      )}
    </div>
  );
};

export default SocialMediaForm;
